import { ColumnDef } from "@tanstack/react-table";
import i18n from "@/lang/i18n";
import { DataTableColumnHeader } from "@/components/custom/DataTableColumnHeader";

export type HubChargerStatusInChargingColumn = {
  charger_number: string;
  vehicle_number: string;
  start_soc: string;
  current_soc: string;
};

export const useInChargingColumns =
  (): ColumnDef<HubChargerStatusInChargingColumn>[] => {

    return [
      {
        accessorKey: "charger_number",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title={`${i18n.t("chargerNumber")}`} className="w-24" />
        ),
      },
      {
        accessorKey: "vehicle_number",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title={`${i18n.t("vehicleNumber")}`} className="w-24" />
        ),
      },
      {
        accessorKey: "start_soc",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title={`${i18n.t("startSOC")}`} className="w-24" />
        ),
      },
      {
        accessorKey: "current_soc",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title={`${i18n.t("currentSOC")}`} className="w-24" />
        ),
      },
    ];
  };
